import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL } from "../Api/dataApi";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [product, setProduct] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/${id}`);
        const data = await response.json();
        setProduct(data);
      } catch (error) {
        console.error(t("error_fetching_product"), error);
      }
    };

    fetchProductDetails();
  }, [id, t]);

  if (!product) {
    return <div>{t("loading")}</div>;
  }

  const images = product.images || [t("default_image")];

  const nextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="product-container">
      <div className="image-productousel">
        {images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="productousel-arrow left-arrow"
            >
              &#8592;
            </button>
            <button
              onClick={nextImage}
              className="productousel-arrow right-arrow"
            >
              &#8594;
            </button>
          </>
        )}
        <img
          src={images[currentIndex]}
          alt={product.title || t("no_title")}
          className="product-img"
        />
      </div>
      <div className="product-detailsall">
        <h3 className="product-name">
          <strong>{product.title || t("no_title")}</strong>
        </h3>
        <p className="product-description-details">
          <strong>
            <i className="fas fa-info-circle"></i> {t("prodect-description")}
          </strong>{" "}
          <br />
          {product.description || t("no_description")}
        </p>
        <p className="product-price">
          <i className="fas fa-dollar-sign"></i> {t("price")}:{" "}
          {product.price || t("no_price")}
        </p>
        <p className="product-location">
          <i className="fas fa-map-marker-alt"></i> {t("location")}:{" "}
          {product.location || t("no_location")}
        </p>

        {/* عرض بيانات البائع (اسم ورقم الهاتف) من API */}
        <div className="user-info">
          {product.sellername && product.sellerid && (
            <>
              <p>
                <i className="fas fa-user"></i> {t("user_name")}:{" "}
                {product.sellername}
              </p>
              <p>
                <i className="fas fa-phone-alt"></i> {t("user_phone")}:{" "}
                {product.sellerid}
              </p>
            </>
          )}
        </div>

        {product.category === "Cars" && (
          <>
            <p className="product-brand">
              <i className="fas fa-cogs"></i> {t("brand")}:{" "}
              {product.brand || t("no_brand")}
            </p>
            <p className="product-modelYear">
              <i className="fas fa-calendar-alt"></i> {t("modelYear")}:{" "}
              {product.modelYear || t("no_modelYear")}
            </p>
            <p className="product-km">
              <i className="fas fa-tachometer-alt"></i> {t("km")}:{" "}
              {product.km || t("no_km")}
            </p>
            <p className="product-engineCC">
              <i className="fas fa-cogs"></i> {t("engineCC")}:{" "}
              {product.engineCC || t("no_engineCC")}
            </p>
            <p className="product-fuelType">
              <i className="fas fa-gas-pump"></i> {t("fuelType")}:{" "}
              {product.fuelType || t("no_fuelType")}
            </p>
            <p className="product-transmission">
              <i className="fas fa-exchange-alt"></i> {t("transmission")}:{" "}
              {product.transmission || t("no_transmission")}
            </p>
            <p className="product-drivetrain">
              <i className="fas fa-road"></i> {t("drivetrain")}:{" "}
              {product.drivetrain || t("no_drivetrain")}
            </p>
            <p className="product-doors">
              <i className="fas fa-door-closed"></i> {t("doors")}:{" "}
              {product.doors || t("no_doors")}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
